import React from 'react';
import PropTypes from 'prop-types';


const CloseSymbol = ({ color, width }) => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <line stroke={color} strokeWidth={width} x1="0" x2="32" y1="0" y2="32" />
    <line stroke={color} strokeWidth={width} x1="32" x2="0" y1="0" y2="32" />
  </svg>
);

CloseSymbol.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
};

CloseSymbol.defaultProps = {
  color: 'black',
  width: '1px',
};

export default CloseSymbol;
